import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import checkIfLinkIsCurrent from "@components/WebsiteRevamp/utils/checkIfLinkIsCurrent"
import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Image from "next/image"
import Link from "next/link"
import {useRouter} from "next/router"
import React from "react"

import styles from "./Subheader.module.scss"

type Props = {
	data: MenuModuleType[]
}

const ProductsSubheader = (props: Props) => {
	const items = props.data

	const router = useRouter()

	return (
		<>
			<ContainerWrapper className={styles.subheaderBox}>
				{items.map((item, index) => {
					const {current, parent} = checkIfLinkIsCurrent(
						router.asPath,
						item.link,
						item.subLinksSelect,
					)
					const active = current || parent ? styles.active : ""

					return (
						<React.Fragment key={`product-subheader-${index}`}>
							<Link
								className={`${styles.linkBox}  ${active} ${styles.ItemBox}`}
								href={item?.link ?? ""}
							>
								{item?.menuLinkIconSvg && (
									<div className={styles.logo}>
										<Image
											{...item.menuLinkIconSvg}
											className={styles.LogoImage}
											width={
												item.menuLinkIconSvg?.width ||
												1920
											}
											height={
												item.menuLinkIconSvg?.height ||
												1024
											}
										/>
									</div>
								)}
								<Typography
									as={"p"}
									content={item.subtitle}
									size={Size.XXS}
									variant={Variant.Description}
									// contrast
									noPadding
								/>
							</Link>
						</React.Fragment>
					)
				})}
			</ContainerWrapper>
		</>
	)
}

export default ProductsSubheader
